/** @format */

import React from 'react';
import { GlobalNames } from '../components/GlobalNames';

/**
 * GlobalNamesContainer
 * Container component for GlobalNames
 * Handles data fetching and state management
 */
export const GlobalNamesContainer: React.FC = () => {
  return <GlobalNames />;
};
